import { useMutation } from '@tanstack/react-query';
import settingApprovalApi from '@/features/public/settingApproval/api/settingApprovalApi.ts';

export default function useApproveSetting() {
  return useMutation({
    mutationFn: (token: string) => settingApprovalApi.approve(token),
  });
}
